

import { RadioGroup } from "@headlessui/react";
import classNames from "../../utils/classNames";


export default function Tabs({ viewType, viewTypes, setViewType }) {

  const gridCols = `grid grid-cols-1 lg:grid-cols-${viewTypes.length} gap-3`;

  return (
    <RadioGroup value={viewType} onChange={setViewType} className="my-4">
      <label className="sr-only">
        Choose which view to display
      </label>
      <div className={gridCols}>
        {viewTypes.map((type) => (
          <RadioGroup.Option
            key={`${type.value}`}
            value={type.value}
            className={({ active, checked }) =>
              classNames(
                active ? "ring-2 ring-offset-2 ring-etpink-600" : "",
                checked
                  ? "bg-etpink-600 border-transparent text-white hover:bg-etpink-600"
                  : "bg-white border-gray-200 text-gray-900 hover:bg-gray-50",
                "cursor-pointer focus:outline-none border rounded-md py-1.5 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
              )
            }
          >
            <label as="span">{type.label}</label>
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  )

}